import * as THREE from '../../libs/three.js/build/three.module.js';
import {PropertiesPanel} from './PropertyPanels/PropertiesPanel.js';
import {Utils} from '../utils.js';
import {MeasuringTool} from '../utils/MeasuringTool';
import {ProfileTool} from '../utils/ProfileTool';
import * as Potree from '../Potree';
import {EventTopic, NavigationMode, VolumeTool} from '../Potree';
import {Quickbar} from './quickbar';

export class Sidebar {
  constructor(viewer) {
    this.viewer = viewer;
  }

  createToolIcon(icon, title, callback, rightSide) {
    var styleAddition = '';
    if (rightSide) {
      styleAddition = 'float:right;';
    }

    let element = $(`
			<img src="${icon}"
				id="${title}"
				style="width: 32px; height: 32px;` + styleAddition + `"
				class="button-icon"
				title="${title}"/>
		`);

    element.click(callback);

    return element;
  };

  init() {
    this.initAccordion();
    this.initAppearance();
    this.initToolbar();
    this.initScene();
    this.initNavigation();
    this.initClassificationList();
    this.initClippingTool();
    this.initMeasurementImport();
    this.initMeasurementExport();
    this.initConfigImport();
    this.initConfigExport();
    this.initSettings();
    this.initConfigPresets();
    viewer.setLanguage('de');
    $('#menu_scene')
      .next()
      .show();
    $('#menu_config_presets')
      .next()
      .show();

    $('#potree_version_number')
      .html(Potree.version.major + '.' + Potree.version.minor + Potree.version.suffix);
    $('.perfect_scrollbar')
      .perfectScrollbar();
  };

  initToolbar() {
    let elToolbar = $('#tools');
    let measuringTool = new MeasuringTool(this.viewer);
    // POINT
    elToolbar.append(this.createToolIcon(
      Potree.resourcePath + '/planquadrat/icons/z_point.png',
      'Z-Wert',
      function () {
        $('#menu_measurements')
          .next()
          .slideDown();
        let measurement = measuringTool.startInsertion({
          showDistances: false,
          showAngles: false,
          showCoordinates: true,
          showCoordinatesX: false,
          showCoordinatesY: false,
          showArea: false,
          closed: true,
          maxMarkers: 1,
          name: viewer.scene.getMeasurementName('Punkt'),
        });

        let measurementsRoot = $('#jstree_scene')
          .jstree()
          .get_json('measurements');
        let jsonNode = measurementsRoot.children.find(child => child.data.uuid === measurement.uuid);
        $.jstree.reference(jsonNode.id)
          .deselect_all();
        $.jstree.reference(jsonNode.id)
          .select_node(jsonNode.id);
      },
    ));

    // DISTANCE
    elToolbar.append(this.createToolIcon(
      Potree.resourcePath + '/planquadrat/icons/distance.png',
      'Länge',
      function () {
        $('#menu_measurements')
          .next()
          .slideDown();
        let measurement = measuringTool.startInsertion({
          showDistances: true,
          showArea: false,
          closed: false,
          name: viewer.scene.getMeasurementName('Distanz'),
        });

        let measurementsRoot = $('#jstree_scene')
          .jstree()
          .get_json('measurements');
        let jsonNode = measurementsRoot.children.find(child => child.data.uuid === measurement.uuid);
        $.jstree.reference(jsonNode.id)
          .deselect_all();
        $.jstree.reference(jsonNode.id)
          .select_node(jsonNode.id);
        Sidebar.selectToolIcon('Länge');
      },
    ));

    // HEIGHT
    elToolbar.append(this.createToolIcon(
      Potree.resourcePath + '/planquadrat/icons/height.png',
      'Höhe',
      function () {
        $('#menu_measurements')
          .next()
          .slideDown();
        let measurement = measuringTool.startInsertion({
          showDistances: false,
          showHeight: true,
          showArea: false,
          closed: false,
          maxMarkers: 2,
          name: viewer.scene.getMeasurementName('Höhe'),
        });

        let measurementsRoot = $('#jstree_scene')
          .jstree()
          .get_json('measurements');
        let jsonNode = measurementsRoot.children.find(child => child.data.uuid === measurement.uuid);
        $.jstree.reference(jsonNode.id)
          .deselect_all();
        $.jstree.reference(jsonNode.id)
          .select_node(jsonNode.id);
        Sidebar.selectToolIcon('Höhe');
      },
    ));

    let profileTool = new ProfileTool(this.viewer);
    // PROFILE
    elToolbar.append(this.createToolIcon(
      Potree.resourcePath + '/planquadrat/icons/height_profiles.png',
      'Profil',
      function () {
        $('#menu_measurements')
          .next()
          .slideDown();
        let profile = profileTool.startInsertion({
          name: viewer.scene.getProfileName('Profil'),
        });

        console.dir(viewer.useEDL);

        let measurementsRoot = $('#jstree_scene')
          .jstree()
          .get_json('measurements');
        let jsonNode = measurementsRoot.children.find(child => child.data.uuid === profile.uuid);
        $.jstree.reference(jsonNode.id)
          .deselect_all();
        $.jstree.reference(jsonNode.id)
          .select_node(jsonNode.id);
        Sidebar.selectToolIcon('Profil');
      },
    ));

    // REMOVE ALL
    elToolbar.append(this.createToolIcon(
      Potree.resourcePath + '/planquadrat/icons/reset_tools.png',
      'Entfernen',
      function () {
        if (confirm('Möchten Sie alle Messungen löschen?')) {
          viewer.scene.removeAllMeasurements();
          Sidebar.deselectToolIcons();
        }
      }, true,
    ));
  }

  initScene() {
    let elScene = $('#menu_scene');
    let elObjects = elScene.next()
      .find('#scene_objects');
    let elProperties = $('#scene_object_properties');

    {
      let elExport = elScene.next()
        .find('#scene_export');

      let geoJSONIcon = `${Potree.resourcePath}/icons/file_geojson.svg`;
      let dxfIcon = `${Potree.resourcePath}/icons/file_dxf.svg`;

      elExport.append(`
				Export: <br>
				<a href="#" download="measure.json"><img name="geojson_export_button" src="${geoJSONIcon}" class="button-icon" style="height: 24px" /></a>
				<a href="#" download="measure.dxf"><img name="dxf_export_button" src="${dxfIcon}" class="button-icon" style="height: 24px" /></a>
			`);

      let elDownloadJSON = elExport.find('img[name=geojson_export_button]')
        .parent();
      elDownloadJSON.click(() => {
        let scene = viewer.scene;
        let measurements = [...scene.measurements, ...scene.profiles, ...scene.volumes];

        let geoJson = Potree.GeoJSONExporter.toString(measurements);

        let url = window.URL.createObjectURL(new Blob([geoJson], { type: 'data:application/octet-stream' }));
        elDownloadJSON.attr('href', url);
      });

      let elDownloadDXF = elExport.find('img[name=dxf_export_button]')
        .parent();
      elDownloadDXF.click(() => {
        let scene = viewer.scene;
        let measurements = [...scene.measurements, ...scene.profiles, ...scene.volumes];

        let dxf = Potree.DXFExporter.toString(measurements);

        let url = window.URL.createObjectURL(new Blob([dxf], { type: 'data:application/octet-stream' }));
        elDownloadDXF.attr('href', url);
      });
    }

    let propertiesPanel = new PropertiesPanel(elProperties, viewer);
    propertiesPanel.setScene(viewer.scene);

    localStorage.removeItem('jstree');

    let tree = $(`<div id="jstree_scene"></div>`);
    elObjects.append(tree);

    tree.jstree({
      'plugins': ['checkbox', 'state'],
      'core': {
        'dblclick_toggle': false,
        'state': {
          'checked': true,
        },
        'check_callback': true,
        'expand_selected_onload': true,
      },
      'checkbox': {
        'keep_selected_style': true,
        'three_state': false,
        'whole_node': false,
        'tie_selection': false,
      },
    });

    let createNode = (parent, text, icon, object) => {
      let nodeID = tree.jstree('create_node', parent, {
          'text': text,
          'icon': icon,
          'data': object,
        },
        'last', false, false);

      if (object.visible) {
        tree.jstree('check_node', nodeID);
      } else {
        tree.jstree('uncheck_node', nodeID);
      }

      return nodeID;
    };

    let hideNode = (nodeId) => {
      tree.jstree('hide_node', nodeId);
    };
    let showNode = (nodeId) => {
      tree.jstree('show_node', nodeId);
    };

    let pcID = tree.jstree('create_node', '#', {
      'text': '<b>Punktwolken</b>',
      'id': 'pointclouds',
    }, 'last', false, false);
    let measurementID = tree.jstree('create_node', '#', {
      'text': '<b>Messungen</b>',
      'id': 'measurements',
    }, 'last', false, false);
    let annotationsID = tree.jstree('create_node', '#', {
      'text': '<b>Annotations</b>',
      'id': 'annotations',
    }, 'last', false, false);
    let otherID = tree.jstree('create_node', '#', {
      'text': '<b>Sonstiges</b>',
      'id': 'other',
    }, 'last', false, false);

    tree.jstree('check_node', pcID);
    tree.jstree('check_node', measurementID);
    tree.jstree('check_node', annotationsID);
    tree.jstree('check_node', otherID);

    hideNode(measurementID);
    hideNode(annotationsID);
    hideNode(otherID);

    tree.off('dblclick').on('dblclick','.jstree-anchor', renameNode);

    function renameNode() {
      const instance = $.jstree.reference(this),
          node = instance.get_node(this);
      const old = node.text.replace(/\s+$/, ''); // trim right spaces

      if (!node.data || !node.data.name) {
        return;
      }

      instance.edit(node, null, function(node, success, cancelled) {
        if (!success || cancelled) return;
        if (node.text.replace(/\s+$/, '') === old) return;

        node.data.name = node.text;
      });
    }

    tree.on('create_node.jstree', function (e, data) {
      tree.jstree('open_all');
    });

    tree.on('select_node.jstree', function (e, data) {
      let object = data.node.data;
      propertiesPanel.set(object);

      viewer.inputHandler.deselectAll();

      if (object instanceof Potree.Volume) {
        viewer.inputHandler.toggleSelection(object);
      }

      $(viewer.renderer.domElement)
        .focus();
    });

    tree.on('deselect_node.jstree', function (e, data) {
      propertiesPanel.set(null);
    });

    tree.on('delete_node.jstree', function (e, data) {
      propertiesPanel.set(null);
    });

    tree.on('dblclick', '.jstree-anchor', function (e) {
      let instance = $.jstree.reference(this);
      if (!instance) return;
      let node = instance.get_node(this);
      let object = node.data;

      // ignore double click on checkbox
      if (e.target.classList.contains('jstree-checkbox')) {
        return;
      }

      if (object instanceof Potree.PointCloudTree) {
        let box = viewer.getBoundingBox([object]);
        let node = new THREE.Object3D();
        node.boundingBox = box;
        viewer.zoomTo(node, 1, 500);
      } else if (object instanceof Potree.Measure) {
        let points = object.points.map(p => p.position);
        let box = new THREE.Box3().setFromPoints(points);
        if (box.getSize()
          .length() > 0) {
          let node = new THREE.Object3D();
          node.boundingBox = box;
          viewer.zoomTo(node, 2, 500);
        }
      } else if (object instanceof Potree.Profile) {
        let points = object.points;
        let box = new THREE.Box3().setFromPoints(points);
        if (box.getSize()
          .length() > 0) {
          let node = new THREE.Object3D();
          node.boundingBox = box;
          viewer.zoomTo(node, 1, 500);
        }
      } else if (object instanceof Potree.Volume) {

        let box = object.boundingBox.clone()
          .applyMatrix4(object.matrixWorld);

        if (box.getSize()
          .length() > 0) {
          let node = new THREE.Object3D();
          node.boundingBox = box;
          viewer.zoomTo(node, 1, 500);
        }
      } else if (object instanceof Potree.Annotation) {
        object.moveHere(viewer.scene.getActiveCamera());
      } else if (object instanceof Potree.PolygonClipVolume) {
        let dir = object.camera.getWorldDirection();
        let target;

        if (object.camera instanceof THREE.OrthographicCamera) {
          dir.multiplyScalar(object.camera.right);
          target = new THREE.Vector3().addVectors(object.camera.position, dir);
          viewer.setCameraMode(Potree.CameraMode.ORTHOGRAPHIC);
        } else if (object.camera instanceof THREE.PerspectiveCamera) {
          dir.multiplyScalar(viewer.scene.view.radius);
          target = new THREE.Vector3().addVectors(object.camera.position, dir);
          viewer.setCameraMode(Potree.CameraMode.PERSPECTIVE);
        }

        viewer.scene.view.position.copy(object.camera.position);
        viewer.scene.view.lookAt(target);
      } else if (object instanceof THREE.SpotLight) {
        let distance = (object.distance > 0) ? object.distance / 4 : 5 * 1000;
        let position = object.position;
        let target = new THREE.Vector3().addVectors(
          position,
          object.getWorldDirection()
            .multiplyScalar(distance));

        viewer.scene.view.position.copy(object.position);
        viewer.scene.view.lookAt(target);
      } else if (object instanceof THREE.Object3D) {
        let box = new THREE.Box3().setFromObject(object);

        if (box.getSize()
          .length() > 0) {
          let node = new THREE.Object3D();
          node.boundingBox = box;
          viewer.zoomTo(node, 1, 500);
        }
      }
    });

    tree.on('uncheck_node.jstree', function (e, data) {
      let object = data.node.data;

      if (object) {
        object.visible = false;
      }

      if (data.node.children) {
        data.node.children.forEach(x => {
          tree.jstree('uncheck_node', x);
        });
      }
    });

    tree.on('check_node.jstree', function (e, data) {
      let object = data.node.data;

      if (object) {
        object.visible = true;
      }

      if (data.node.children) {
        data.node.children.forEach(x => {
          tree.jstree('check_node', x);
        });
      }
    });

    let onPointCloudAdded = (e) => {
      let pointcloud = e.pointcloud;
      let cloudIcon = `${Potree.resourcePath}/icons/cloud.svg`;
      let nodeID = createNode(pcID, pointcloud.name, cloudIcon, pointcloud);
      Utils.pointcloudNodeIDs[pointcloud.name] = nodeID;
    };

    let onMeasurementAdded = (e) => {
      let measurement = e.measurement;
      let icon = Utils.getMeasurementIcon(measurement);
      let nodeID = createNode(measurementID, measurement.name, icon, measurement);

      showNode(measurementID);

      Utils.measurementNodeIDs[measurement.name] = nodeID;
    };

    let onVolumeAdded = (e) => {
      const volume = e.volume;
      Utils.volumes.push(volume);

      showNode(measurementID);
      const icon = Utils.getMeasurementIcon(volume);
      const nodeID = createNode(measurementID, volume.name, icon, volume);
      Utils.volumeNodeIDs[volume.name] = nodeID;

      volume.addEventListener('visibility_changed', () => {
        if (volume.visible) {
          tree.jstree('check_node', nodeID);
        } else {
          tree.jstree('uncheck_node', nodeID);
        }
      });
    };

    let onProfileAdded = (e) => {
      let profile = e.profile;
      let icon = Utils.getMeasurementIcon(profile);
      let nodeID = createNode(measurementID, profile.name, icon, profile);
      showNode(measurementID);
      Utils.profileNodeIDs[profile.name] = nodeID;
    };

    let onAnnotationAdded = (e) => {
      let annotation = e.annotation;

      let annotationIcon = `${Potree.resourcePath}/icons/annotation.svg`;
      let parentID = this.annotationMapping.get(annotation.parent);
      if (parentID == null) {
        parentID = annotationsID;
      }

      let annotationID = createNode(parentID, annotation.title, annotationIcon, annotation);
      this.annotationMapping.set(annotation, annotationID);

      showNode(annotationID);
      Utils.annotationNodeIDs[annotation.title] = annotationID;

      //let node = createNode(annotationsID, annotation.name, icon, volume);
      //oldScene.annotations.removeEventListener('annotation_added', this.onAnnotationAdded);
    };

    viewer.scene.addEventListener('pointcloud_added', onPointCloudAdded);
    viewer.scene.addEventListener('measurement_added', onMeasurementAdded);
    viewer.scene.addEventListener('profile_added', onProfileAdded);
    viewer.scene.addEventListener('volume_added', onVolumeAdded);
    viewer.scene.addEventListener('polygon_clip_volume_added', onVolumeAdded);
    viewer.scene.annotations.addEventListener('annotation_added', onAnnotationAdded);

    let onMeasurementRemoved = (e) => {
      let measurementsRoot = $('#jstree_scene')
        .jstree()
        .get_json('measurements');
      let jsonNode = measurementsRoot.children.find(child => child.data.uuid === e.measurement.uuid);

      if (measurementsRoot.children.length === 1) {
        hideNode(measurementID);
      }
      tree.jstree('delete_node', jsonNode.id);
    };

    let onVolumeRemoved = (e) => {
      let measurementsRoot = $('#jstree_scene')
        .jstree()
        .get_json('measurements');
      let jsonNode = measurementsRoot.children.find(child => child.data.uuid === e.volume.uuid);

      if (measurementsRoot.children.length === 1) {
        hideNode(measurementID);
      }
      tree.jstree('delete_node', jsonNode.id);
    };

    let onProfileRemoved = (e) => {
      let measurementsRoot = $('#jstree_scene')
        .jstree()
        .get_json('measurements');
      let jsonNode = measurementsRoot.children.find(child => child.data.uuid === e.profile.uuid);

      if (measurementsRoot.children.length === 1) {
        hideNode(measurementID);
      }
      tree.jstree('delete_node', jsonNode.id);
    };

    viewer.scene.addEventListener('measurement_removed', onMeasurementRemoved);
    viewer.scene.addEventListener('volume_removed', onVolumeRemoved);
    viewer.scene.addEventListener('profile_removed', onProfileRemoved);

    {
      let annotationIcon = `${Potree.resourcePath}/icons/annotation.svg`;
      this.annotationMapping = new Map();
      this.annotationMapping.set(viewer.scene.annotations, annotationsID);
      viewer.scene.annotations.traverseDescendants(annotation => {
        let parentID = this.annotationMapping.get(annotation.parent);
        let annotationID = createNode(parentID, annotation.title, annotationIcon, annotation);
        this.annotationMapping.set(annotation, annotationID);
      });
    }

    for (let pointcloud of viewer.scene.pointclouds) {
      onPointCloudAdded({ pointcloud: pointcloud });
    }

    for (let measurement of viewer.scene.measurements) {
      onMeasurementAdded({ measurement: measurement });
    }

    for (let volume of [...viewer.scene.volumes, ...viewer.scene.polygonClipVolumes]) {
      onVolumeAdded({ volume: volume });
    }

    for (let profile of viewer.scene.profiles) {
      onProfileAdded({ profile: profile });
    }

    {
      let cameraIcon = `${Potree.resourcePath}/icons/orthographic-camera.svg`;
      const cameraNodeId = createNode(otherID, 'Kamera', cameraIcon, new THREE.Camera());
      hideNode(cameraNodeId)
    }

    viewer.addEventListener(EventTopic.SceneChanged, (e) => {
      propertiesPanel.setScene(e.scene);

      for (var key in Utils.pointcloudNodeIDs) {
        tree.jstree('delete_node', Utils.pointcloudNodeIDs[key]);
      }
      for (var key in Utils.annotationNodeIDs) {
        tree.jstree('delete_node', Utils.annotationNodeIDs[key]);
      }

      Utils.pointcloudNodeIDs = {};
      Utils.measurementNodeIDs = {};
      Utils.profileNodeIDs = {};
      Utils.volumeNodeIDs = {};
      Utils.annotationNodeIDs = {};
      Utils.volumes = [];

      e.oldScene.removeMeasurements();

      e.oldScene.removeEventListener('pointcloud_added', onPointCloudAdded);
      e.oldScene.removeEventListener('measurement_added', onMeasurementAdded);
      e.oldScene.removeEventListener('profile_added', onProfileAdded);
      e.oldScene.removeEventListener('volume_added', onVolumeAdded);
      e.oldScene.removeEventListener('polygon_clip_volume_added', onVolumeAdded);
      e.oldScene.removeEventListener('measurement_removed', onMeasurementRemoved);
      e.oldScene.removeEventListener('profile_removed', onProfileRemoved);
      e.oldScene.removeEventListener('volume_removed', onVolumeRemoved);
      e.oldScene.annotations.removeEventListener('annotation_added', onAnnotationAdded);

      e.scene.addEventListener('pointcloud_added', onPointCloudAdded);
      e.scene.addEventListener('measurement_added', onMeasurementAdded);
      e.scene.addEventListener('profile_added', onProfileAdded);
      e.scene.addEventListener('volume_added', onVolumeAdded);
      e.scene.addEventListener('polygon_clip_volume_added', onVolumeAdded);
      e.scene.addEventListener('measurement_removed', onMeasurementRemoved);
      e.scene.addEventListener('profile_removed', onProfileRemoved);
      e.scene.addEventListener('volume_removed', onVolumeRemoved);
      e.scene.annotations.addEventListener('annotation_added', onAnnotationAdded);
    });
  }

  initAccordion() {
    $('.accordion > h3')
      .each(function () {
        let header = $(this);
        let content = $(this)
          .next();

        //header.addClass('accordion-header ui-widget');
        //content.addClass('accordion-content ui-widget');

        content.hide();

        header.click(function () {
          content.slideToggle();
        });
      });

    let languages = [
      ['EN', 'en'],
      ['FR', 'fr'],
      ['DE', 'de'],
    ];

    let elLanguages = $('#potree_languages');
    for (let i = 0; i < languages.length; i++) {
      let [key, value] = languages[i];
      let element = $(`<a>${key}</a>`);
      element.click(() => viewer.setLanguage(value));

      if (i === 0) {
        element.css('margin-left', '30px');
      }

      elLanguages.append(element);

      if (i < languages.length - 1) {
        elLanguages.append($(document.createTextNode(' - ')));
      }
    }

    // to close all, call
    // $(".accordion > div").hide()

    // to open the, for example, tool menu, call:
    // $("#menu_tools").next().show()
  }

  initAppearance() {

    $('#sldPointBudget')
      .slider({
        value: viewer.getPointBudget(),
        min: 100 * 1000,
        max: 100 * 1000 * 1000,
        step: 1000,
        slide: function (event, ui) {
          viewer.setPointBudget(ui.value);
        },
      });

    $('#sldPointSize')
      .slider({
        value: viewer.getPointSize(),
        min: 1,
        max: 3,
        step: 0.01,
        slide: function (event, ui) {
          viewer.setPointSize(ui.value);
        },
      });

    viewer.addEventListener('point_size_changed', function (event) {
      $('#lblPointSize')[0].innerHTML = Utils.addCommas(viewer.getPointSize());
      $('#sldPointSize')
        .slider({ value: viewer.getPointSize() });
    });

    viewer.addEventListener('point_budget_changed', function (event) {
      $('#lblPointBudget')[0].innerHTML = Utils.addCommas(viewer.getPointBudget());
      $('#sldPointBudget')
        .slider({ value: viewer.getPointBudget() });
    });

    viewer.addEventListener('edl_radius_changed', function (event) {
      $('#lblEDLRadius')[0].innerHTML = viewer.getEDLRadius()
        .toFixed(1);
      $('#sldEDLRadius')
        .slider({ value: viewer.getEDLRadius() });
    });

    viewer.addEventListener('edl_strength_changed', function (event) {
      $('#lblEDLStrength')[0].innerHTML = viewer.getEDLStrength()
        .toFixed(1);
      $('#sldEDLStrength')
        .slider({ value: viewer.getEDLStrength() });
    });

    viewer.addEventListener('background_changed', function (event) {
      $('input[name=background][value=\'' + viewer.getBackground() + '\']')
        .prop('checked', true);
    });

    $('#lblPointBudget')[0].innerHTML = Utils.addCommas(viewer.getPointBudget());
    $('#lblPointSize')[0].innerHTML = Utils.addCommas(viewer.getPointSize());

    let elBackground = $(`#background_options`);
    elBackground.selectgroup();

    elBackground.find('input')
      .click((e) => {
        viewer.setBackground(e.target.value);
      });

    let currentBackground = viewer.getBackground();
    $(`input[name=background_options][value=${currentBackground}]`)
      .trigger('click');
  }

  initClippingTool() {
    {
      let elClipTask = $('#cliptask_options');
      elClipTask.selectgroup({ title: 'Ausschnitts Art' });

      elClipTask.find('input')
        .click((e) => {
          viewer.setClipTask(Potree.ClipTask[e.target.value]);
        });

      let currentClipTask = Object.keys(Potree.ClipTask)
        .filter(key => Potree.ClipTask[key] === viewer.clipTask);
      elClipTask.find(`input[value=${currentClipTask}]`)
        .trigger('click');
    }

    {
      let elClipMethod = $('#clipmethod_options');
      elClipMethod.selectgroup({ title: 'Clip Method' });

      elClipMethod.find('input')
        .click((e) => {
          viewer.setClipMethod(Potree.ClipMethod[e.target.value]);
        });

      let currentClipMethod = Object.keys(Potree.ClipMethod)
        .filter(key => Potree.ClipMethod[key] === viewer.clipMethod);
      elClipMethod.find(`input[value=${currentClipMethod}]`)
        .trigger('click');
    }

    let clippingToolBar = $('#clipping_tools');
    let volumeTool = new VolumeTool(this.viewer);
    // CLIP VOLUME
    clippingToolBar.append(this.createToolIcon(
      Potree.resourcePath + '/icons/clip_volume.svg',
      'Volumen',
      () => {
        let item = volumeTool.startInsertion({
          clip: true,
          name: viewer.scene.getVolumeName('Volumen'),
        });

        let measurementsRoot = $('#jstree_scene')
          .jstree()
          .get_json('measurements');
        let jsonNode = measurementsRoot.children.find(child => child.data.uuid === item.uuid);
        $.jstree.reference(jsonNode.id)
          .deselect_all();
        $.jstree.reference(jsonNode.id)
          .select_node(jsonNode.id);
      },
    ));

    // CLIP POLYGON
    clippingToolBar.append(this.createToolIcon(
      Potree.resourcePath + '/icons/clip-polygon.svg',
      'Polygon',
      () => {
        let item = viewer.clippingTool.startInsertion({
          type: 'polygon',
          name: viewer.scene.getVolumeName('Polygon'),
        });

        let measurementsRoot = $('#jstree_scene')
          .jstree()
          .get_json('measurements');
        let jsonNode = measurementsRoot.children.find(child => child.data.uuid === item.uuid);
        $.jstree.reference(jsonNode.id)
          .deselect_all();
        $.jstree.reference(jsonNode.id)
          .select_node(jsonNode.id);
      },
    ));

    {// SCREEN BOX SELECT
      let boxSelectTool = new Potree.ScreenBoxSelectTool(viewer);

      clippingToolBar.append(this.createToolIcon(
        Potree.resourcePath + '/icons/clip-screen.svg',
        'Rechteck',
        () => {
          if (!(viewer.scene.getActiveCamera() instanceof THREE.OrthographicCamera)) {
            viewer.postMessage(`Switch to Orthographic Camera Mode before using the Screen-Box-Select tool.`,
              { duration: 2000 });
            return;
          }

          let item = boxSelectTool.startInsertion({
            name: viewer.scene.getVolumeName('Rechteck'),
          });

          let measurementsRoot = $('#jstree_scene')
            .jstree()
            .get_json('measurements');
          let jsonNode = measurementsRoot.children.find(child => child.data.uuid === item.uuid);
          $.jstree.reference(jsonNode.id)
            .deselect_all();
          $.jstree.reference(jsonNode.id)
            .select_node(jsonNode.id);
        },
      ));
    }

    { // REMOVE CLIPPING TOOLS
      clippingToolBar.append(this.createToolIcon(
        Potree.resourcePath + '/planquadrat/icons/reset_tools.png',
        'Entfernen',
        () => {
          viewer.scene.removeAllClipVolumes();
        }, true,
      ));
    }

  }

  initSettings() {
    {
      $('#sldMinNodeSize')
        .slider({
          value: viewer.getMinNodeSize(),
          min: 0,
          max: 1000,
          step: 0.01,
          slide: function (event, ui) {
            viewer.setMinNodeSize(ui.value);
          },
        });

      viewer.addEventListener('minnodesize_changed', function (event) {
        $('#lblMinNodeSize')
          .html(parseInt(viewer.getMinNodeSize()));
        $('#sldMinNodeSize')
          .slider({ value: viewer.getMinNodeSize() });
      });
      $('#lblMinNodeSize')
        .html(parseInt(viewer.getMinNodeSize()));
    }

    {
      let elSplatQuality = $('#splat_quality_options');
      elSplatQuality.selectgroup({ title: '' });

      if (!Potree.Features.HIGH_QUALITY_SPLAT.isSupported()) {
        elSplatQuality.hide();
        $('#splat_quality_options_divider')
          .hide();
      }

      elSplatQuality.find('input')
        .click((e) => {
          if (e.target.value === 'standard') {
            viewer.setUseHQ(false);
          } else if (e.target.value === 'hq') {
            viewer.setUseHQ(true);
          }
        });

      let currentQuality = viewer.useHQ ? 'hq' : 'standard';
      elSplatQuality.find(`input[value=${currentQuality}]`)
        .trigger('click');
    }

    $('#show_bounding_box')
      .click(() => {
        viewer.setShowBoundingBox($('#show_bounding_box')
          .prop('checked'));
      });

    $('#set_freeze')
      .click(function () {
        viewer.setFreeze($('#set_freeze')
          .prop('checked'));
      });

  };

  initNavigation() {
    let elNavigation = $('#navigation');
    let sldMoveSpeed = $('#sldMoveSpeed');
    let lblMoveSpeed = $('#lblMoveSpeed');

    // Orbit
    elNavigation.append(this.createToolIcon(
      Potree.resourcePath + '/planquadrat/icons/orbit_controls.png',
      'Orbit',
      function () {
        viewer.setNavigationMode(NavigationMode.Orbit);
        Sidebar.hideMoveSpeedSlider();
        Quickbar.hideMoveSpeedSlider();
        Sidebar.selectNavigationIcon('Orbit');
      },
    ));

    // Flight
    elNavigation.append(this.createToolIcon(
      Potree.resourcePath + '/planquadrat/icons/flight_controls.png',
      'Flug',
      function () {
        viewer.setNavigationMode(NavigationMode.Flight);
        viewer.fpControls.lockElevation = false;
        Sidebar.showMoveSpeedSlider();
        Quickbar.showMoveSpeedSlider();
        Sidebar.selectNavigationIcon('Flug');
      },
    ));

    // Earth
    elNavigation.append(this.createToolIcon(
      Potree.resourcePath + '/planquadrat/icons/earth_controls.png',
      'Schiebe',
      function () {
        viewer.setNavigationMode(NavigationMode.Earth);
        Sidebar.hideMoveSpeedSlider();
        Quickbar.hideMoveSpeedSlider();
        Sidebar.selectNavigationIcon('Schiebe');
      },
    ));

    // Focus
    elNavigation.append(this.createToolIcon(
      Potree.resourcePath + '/planquadrat/icons/focus_controls.png',
      'Zentrieren',
      function () {
        viewer.fitToScreen();
      },
    ));

    elNavigation.append('<br>');

    elNavigation.append(this.createToolIcon(
        Potree.resourcePath + '/icons/top.svg',
        'Oben',
        function () {
          viewer.setTopView();
        },
    ));

    elNavigation.append(this.createToolIcon(
      Potree.resourcePath + '/icons/left.svg',
      'Links',
      function () {
        viewer.setLeftView();
      },
    ));

    elNavigation.append(this.createToolIcon(
      Potree.resourcePath + '/icons/right.svg',
      'Rechts',
      function () {
        viewer.setRightView();
      },
    ));

    elNavigation.append(this.createToolIcon(
      Potree.resourcePath + '/icons/front.svg',
      'Vorderseite',
      function () {
        viewer.setFrontView();
      },
    ));

    elNavigation.append(this.createToolIcon(
      Potree.resourcePath + '/icons/back.svg',
      'Hinterseite',
      function () {
        viewer.setBackView();
      },
    ));

    elNavigation.append(this.createToolIcon(
      Potree.resourcePath + '/icons/bottom.svg',
      'Unten',
      function () {
        viewer.setBottomView();
      },
    ));

    elNavigation.append(this.createToolIcon(
      Potree.resourcePath + '/icons/navigation_cube.svg',
      'Orientierung anzeigen',
      function () {
        viewer.toggleNavigationCube();
      },
    ));

    elNavigation.append('<br>');

    let elCameraProjection = $(`
			<selectgroup id="camera_projection_options">
				<option id="camera_projection_options_perspective" value="PERSPECTIVE">Perspektive</option>
				<option id="camera_projection_options_orthigraphic" value="ORTHOGRAPHIC">Orthographisch</option>
			</selectgroup>
		`);
    elNavigation.append(elCameraProjection);
    elCameraProjection.selectgroup({ title: 'Kamera Projektion' });
    elCameraProjection.find('input')
      .click((e) => {
        if (viewer.scene.cameraMode != Potree.CameraMode[e.target.value]) {
          viewer.setCameraMode(Potree.CameraMode[e.target.value]);
        }
      });
    let cameraMode = Object.keys(Potree.CameraMode)
      .filter(key => Potree.CameraMode[key] === viewer.scene.cameraMode);
    elCameraProjection.find(`input[value=${cameraMode}]`)
      .trigger('click');

    let speedRange = new THREE.Vector2(1, 10 * 1000);

    let toLinearSpeed = function (value) {
      return Math.pow(value, 4) * speedRange.y + speedRange.x;
    };

    let toExpSpeed = function (value) {
      return Math.pow((value - speedRange.x) / speedRange.y, 1 / 4);
    };

    sldMoveSpeed.slider({
      value: toExpSpeed(viewer.getMoveSpeed()),
      min: 0,
      max: 1,
      step: 0.01,
      slide: function (event, ui) {
        viewer.setMoveSpeed(toLinearSpeed(ui.value));
      },
    });

    viewer.addEventListener('move_speed_changed', function (event) {
      lblMoveSpeed.html(viewer.getMoveSpeed()
        .toFixed(1));
      sldMoveSpeed.slider({ value: toExpSpeed(viewer.getMoveSpeed()) });
    });

    lblMoveSpeed.html(viewer.getMoveSpeed()
      .toFixed(1));
    Sidebar.hideMoveSpeedSlider();
  }

  initConfigPresets() {
    const elConfigPresetsAction = $('#config_presets_action');
    const elConfigPresetsNameInput = $('#config_presets_input_name');

    const configReader = viewer.configReader;
    const self = this;

    const elCreateConfigPresetBtn = this.createToolIcon(
        Potree.resourcePath + '/icons/add.svg',
        'Hinzufügen',
        function () {
          const name = elConfigPresetsNameInput.val();

          if (!name) {
            return;
          }

          elConfigPresetsNameInput.val('');
          configReader.addConfigPreset(name);

          // const canvas = $('#potree_render_area > canvas')[0];
          // const canvasSnapshot = canvas.toDataURL();
          self.refreshConfigPresets();
        }
    );

    elCreateConfigPresetBtn.disabled = true;
    elConfigPresetsNameInput.change(function(event) {
      elCreateConfigPresetBtn.disabled = !event.value;
    })

    elConfigPresetsAction.append(elCreateConfigPresetBtn);

    self.refreshConfigPresets();
  }

  refreshConfigPresets() {
    console.log('REFRESHING', viewer.configs);
    const elConfigPresetsList = $('#config_presets_list');
    elConfigPresetsList.empty();
    for (const config of viewer.configs) {
      const element = $(`<div class="config_preset_item">${config.name ? config.name : 'Default'}</div>`);
      element.click(() => this.loadConfigPreset(config));
      elConfigPresetsList.append(element);
    }
  }

  loadConfigPreset(config) {
    viewer.configReader.applyConfigJson(config);
  }

  initClassificationList() {
    let elClassificationList = $('#classificationList');

    let addClassificationItem = function (code, name) {
      let inputID = 'chkClassification_' + code;

      let element = $(`
				<li>
					<label style="whitespace: nowrap">
						<input id="${inputID}" type="checkbox" checked/>
						<span>${name}</span>
					</label>
				</li>
			`);

      let elInput = element.find('input');

      elInput.click(event => {
        viewer.setClassificationVisibility(code, event.target.checked);
      });

      elClassificationList.append(element);
    };

    addClassificationItem(0, 'never classified');
    addClassificationItem(1, 'unclassified');
    addClassificationItem(2, 'ground');
    addClassificationItem(3, 'low vegetation');
    addClassificationItem(4, 'medium vegetation');
    addClassificationItem(5, 'high vegetation');
    addClassificationItem(6, 'building');
    addClassificationItem(7, 'low point(noise)');
    addClassificationItem(8, 'key-point');
    addClassificationItem(9, 'water');
    addClassificationItem(12, 'overlap');
  }

  initMeasurementImport() {
    let measurementImport = document.getElementById('measurementImport');
    measurementImport.addEventListener('change', (e) => {
      let confirmText = 'Möchten Sie alle Messungen aus der Datei \'' + measurementImport.files[0].name + '\' importieren?';
      if (confirm(confirmText)) {
        var reader = new FileReader();
        reader.readAsText(measurementImport.files[0]);
        reader.onload = (e) => {
          let result = reader.result;
          viewer.applyMeasurementsJson(result);
        };
        measurementImport.value = '';
      } else {
        measurementImport.value = '';
      }
    });
  }

  initMeasurementExport() {
    let measurementExport = document.getElementById('measurementExport');
    measurementExport.onclick = function (e) {
      var exportString = viewer.configReader.stringifyMeasurementsAsTxt();
      this.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(exportString);
    };
  }

  initConfigImport() {
    let configImport = document.getElementById('configImport');
    configImport.addEventListener('change', (e) => {
      let confirmText = 'Möchten Sie alle Einstellungen aus der Datei \'' + configImport.files[0].name + '\' importieren?';
      if (confirm(confirmText)) {
        var reader = new FileReader();
        reader.readAsText(configImport.files[0]);
        reader.onload = (e) => {
          let result = reader.result;
          viewer.configReader.readConfigJsonString(result);
        };
        configImport.value = '';
      } else {
        configImport.value = '';
      }
    });
  }

  initConfigExport() {
    let configExport = document.getElementById('configExport');
    configExport.onclick = function (e) {
      var exportString = viewer.configReader.stringifyFullConfig();
      this.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(exportString);
    };
  }

  static showMoveSpeedSlider() {
    $('#move_speed_container')
      .css('display', 'block');
  }

  static hideMoveSpeedSlider() {
    $('#move_speed_container')
      .css('display', 'none');
  }

  static selectToolIcon(title) {
    Sidebar.deselectToolIcons();
    $('img[id="' + title + '"]')
      .css('background-color', '#982d32');
  }

  static deselectToolIcons() {
    $('.toolbar-links > img')
      .css('background-color', '');
    $('#tools > img')
      .css('background-color', '');
  }

  static selectNavigationIcon(title) {
    Sidebar.deselectNavigationIcons();
    $('img[id="' + title + '"]')
      .css('background-color', '#982d32');
  }

  static deselectNavigationIcons() {
    $('.navigation-links > img')
      .css('background-color', '');
    $('#navigation > img')
      .css('background-color', '');
  }
}
